import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  console.log('Protected route - User:', user); // Debug log
  console.log('Protected route - Loading:', loading); // Debug log

  if (loading) {
    console.log('Protected route - Still loading'); // Debug log
    return <div>Loading...</div>;
  }

  if (!user) {
    console.log('Protected route - No user, redirecting to login'); // Debug log
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  console.log('Protected route - User authenticated, rendering children'); // Debug log
  return children;
};

export default Protected;